import { Box } from "@mui/material";
import React from "react";

export default function FooterSection({ title }) {
    return (
        <Box
            sx={{
                mb: 3,
                textAlign: "center",
                mt: 3,
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img
                    src="/static/coursesCrop.png"
                    alt="Header Graphic"
                    style={{
                        width: "100%",
                        borderRadius: "10px",
                        objectFit: "cover",
                    }}
                />
            </Box>
        </Box>
    );
}
